<template lang="pug">
  div
    Header
    v-container(fluid)
      router-view
</template>
<script>
export default {
  components: {
    Header: () => import('../../components/Header')
  }
}
</script>
